import Vue from 'vue'
import Loading from './loading.vue'

const LoadingBox = Vue.extend(Loading)

Loading.install = (content, options) => {
  options = Object.assign({
    content
  }, options)
  let instance = new LoadingBox({ data: options }).$mount()
  document.body.appendChild(instance.$el)
  return instance
}

export default Loading
